/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StressAreaGroupDto } from '../../models/stress-area-group-dto';

export interface CreateStressAreaGroup$Params {
      body: StressAreaGroupDto
}

export function createStressAreaGroup(http: HttpClient, rootUrl: string, params: CreateStressAreaGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<StressAreaGroupDto>> {
  const rb = new RequestBuilder(rootUrl, createStressAreaGroup.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StressAreaGroupDto>;
    })
  );
}

createStressAreaGroup.PATH = '/v1/stressareagroup';
